import * as orders from '../actions/orders'

import { Order } from '../../core/models/order'
import { ErpOrder } from '../models/orderline'
import { Entities, generateEntities } from '../../core/helpers/entities';
import { RequestWrap } from '../../core/models/request-wrap';
import { createSelector } from '@ngrx/store';

export interface State {
  expanding: boolean
  loading: boolean
  lastLineId: string
  canExpand: boolean
  lines: { [id: string]: ErpOrder}
  currentPage: number
  nextPage: number
  total: number
  totalPages: number

  // Deprecated
  numbers: string[]
  orders: { [number: string]: Order }
}

const initialState: State = {
  expanding: false,
  loading: false,
  canExpand: false,
  lastLineId: null,
  lines: {},
  currentPage: 1,
  nextPage: 2,
  totalPages: 1,
  total: 0,
  numbers: [],
  orders: {}
}

export function reducer(
  state = initialState,
  action: orders.Actions
) {
  let wrap: RequestWrap<ErpOrder[]>
  let generatedData: Entities<ErpOrder>

  switch(action.type){
    case orders.ADD:
      let order = action.payload

      return {
        ...state,
        numbers: [...state.numbers, order._id],
        orders: {
          ...state.orders,
          [order._id]: order
        }
      }

    case orders.LOAD:
      return {
        ...state,
        loading: true,
        lastLineId: null,
        lines: {}
      }

    case orders.LOAD_SUCCESS:
      wrap = action.payload
      generatedData = generateEntities(wrap)

      return {
        ...state,
        loading: false,
        numbers: generatedData.ids,
        lines: generatedData.entities,
        currentPage: 1,
        nextPage: 2,
        totalPages: generatedData.totalPages,
        total: generatedData.totalCount
      }

    case orders.LOAD_FAILED:
      return {
        ...state,
        loading: false,

      }

    case orders.EXPAND: {
      if ((state.total === state.numbers.length) || !state.total) {
        return {
          ...state,
          expanding: false
        }
      } else {
        return {
          ...state,
          expanding: true
        }
      }
    }

    case orders.EXPAND_SUCCESS:
      wrap = action.payload
      generatedData = generateEntities(wrap)

      return {
        ...state,
        expanding: false,
        numbers: [...state.numbers, ...generatedData.ids],
        lines: {...state.lines, ...generatedData.entities},
        currentPage: ++state.currentPage,
        nextPage: ++state.nextPage
      }

    case orders.EXPAND_FAILED:
      return {
        ...state,
        expanding: false
      }

    default:
      return state
  }
}

// Deprecated
export const getOrderNumbers = (state: State) => state && state.numbers
export const getOrdersIndexed = (state: State) => state.orders

// Public Selectors
export const isExpanding = (state: State) => state.expanding
export const isLoading = (state: State) => state.loading
export const getLastLineId = (state: State) => state.lastLineId
export const getLines = (state: State) => state && state.lines
export const getLineCount = (state: State) => state.lines.length
export const canExpand = (state: State) => state.totalPages > state.currentPage

export const getAll = createSelector(
  getLines,
  getOrderNumbers,
  (orders, ids) => ids.map(id => orders[id])
)
